import { systemCodeApi } from '@/api';
export default {
    async getBankCode() {
        const response = await systemCodeApi.getBankCode();
        return response.data;
    },
    async getInsuranceCode() {
        const response = await systemCodeApi.getInsuranceCode();
        return response.data;
    },
};
